/**
 * Chip/status key for Ad Deliver list and detail (distinct from raw API fields).
 * Approve is terminal (IPD-400): approved rows arrive finalized (final_approved, filled chip);
 * rejection stays a moderator decision (moderation_rejected, outlined). final_rejected only
 * appears for pre-collapse rows.
 */
export function deliveryModerationChipStatus(d) {
  if (!d) return "pending";
  const fin = (d.finalized_status || "").toLowerCase();
  const st = (d.moderation_status || "").toLowerCase();
  if (fin === "rejected") return "final_rejected";
  if (fin === "approved") return "final_approved";
  if (st === "approved") return "moderation_approved";
  if (st === "rejected") return "moderation_rejected";
  return "pending";
}

/**
 * Ad Moderation queue row — same chip keys/labels/colors as Ad Deliver (`deliveryModerationChipStatus`).
 * List API uses `status` for moderator decision; deliver API uses `moderation_status`.
 */
export function moderationTableChipStatus(m) {
  return deliveryModerationChipStatus({
    moderation_status: m?.status,
    finalized_status: m?.finalized_status,
  });
}

/** True if row is rejected at moderation and/or final layer (e.g. rejection feedback UI). */
export function isDeliveryRejected(d) {
  if (!d) return false;
  const fin = (d.finalized_status || "").toLowerCase();
  const st = (d.moderation_status || "").toLowerCase();
  return fin === "rejected" || st === "rejected";
}

/** Resubmit is allowed after a rejection (IPD-400: reject is the moderator's final word; nothing finalizes it later). */
export function isDeliveryFinalRejected(d) {
  return isDeliveryRejected(d);
}
